<template>
  <div>
    <NavBarAdmin></NavBarAdmin>
    <div class="card p-1 mt-3 mb-3 w-75 mx-auto border-danger">
      <p>
        <br>
        {{ instruction5 }} <strong><i>indispensable</i></strong> que exista su <strong><i>precio asociado.</i></strong>
        <br> {{ instruction6 }}<router-link class="link1" to="/Admin/ListPrices">Listado de precios</router-link>
        {{ instruction7 }}
      </p>
    </div>
    <button class="btn btn-danger  float-end me-5 mb-3">
      <router-link to="/Admin/TubeNew" class="link2">Crear nuevo tubo</router-link>
    </button>
    <h4 class="mt-4 mb-3">
      Guía de tubos metálicos
    </h4>
    <div class="popup">
      <TubeTypesList v-show="showList" :sendTubeInfo="tubeInfo" @close-list="closeList"></TubeTypesList>
    </div>
    <div>
      <TubeCatalogue @sendMainTubeIdForTypes="getTubeIdForTypes" @sendMainTubeIdForEdit="getMainTubeIdForEdit">
      </TubeCatalogue>
    </div>
    <EditTubeForm v-show="showEditForm" :sendTubeId="tubeId" @close="closeEditForm"></EditTubeForm>
    <FooterAdmin></FooterAdmin>
  </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue";
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue";
import TubeCatalogue from "@/components/Admin/Tube/TubeCatalogueComponent.vue";
import TubeTypesList from "@/components/Admin/Tube/TubeTypesListComponent.vue";
import EditTubeForm from "@/components/Admin/Tube/EditTubeAndTypesComponent.vue";
export default {
  components: {
    name: "TubeCatalogue",
    NavBarAdmin,
    FooterAdmin,
    TubeCatalogue,
    TubeTypesList,
    EditTubeForm,
  },
  data() {
    return {
      tubeId: null,
      tubeInfo: [],
      showList: false,
      showEditForm: false,
      //Mensajes en pantalla
      instruction5:
        "Tenga en cuenta que antes de de crear cualquier lámina es ",
      instruction6:
        "Revise el ",
      instruction7: ", sí ninguno obedece a sus necesidades cree uno nuevo.",
    };
  },
  methods: {
    getTubeIdForTypes(data) {
      this.showList = true;
      this.tubeInfo = data;
      //console.log(this.profileInfo);
    },
    getMainTubeIdForEdit(data) {
      this.tubeId = data;
      this.showEditForm = true;
    },
    closeList() {
      this.showList = false;
    },
    closeEditForm() {
      this.showEditForm = false;
    },
  },
};
</script>
<style scoped>
.popup {
  position: fixed;
  top: 50%;
  /* Centrar verticalmente en la mitad de la pantalla */
  left: 50%;
  /* Centrar horizontalmente en la mitad de la pantalla */
  transform: translate(-50%, -50%);
  /* Alinear al centro */
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  z-index: 999;
  /* Asegurarse de que esté en el frente */
  max-height: 80vh;
  /* Limitar la altura del popup al 80% del alto de la ventana */
  overflow-y: auto;
  /* Habilitar el desplazamiento vertical cuando el contenido es más alto que el popup */
}

.link1 {
  color: #9d0e15;
}
</style>

